export default __webpack_public_path__ + "static/media/CSServicesHeader.95cf6044.png";